import Api from '../utils/api'

export const signin = async (params) => {
  return await Api.get('/auth/signin', params).then((res) => {
    return res
  })
}

export const signup = async (params) => {
  return await Api.post('/auth/signup', params).then((res) => {
    return res
  })
}

export const getProfileApi = async (params) => {
  return await Api.get('/me/profile', params).then((res) => {
    return res
  })
}